/** Styl komponenty tabs (bývalé tab-views) k tématu Erma */
export const TabsStyles = {
  tablist: {
    borderWidth: '0',
    borderColor: 'var(--erma-secondary-220)'
  },
  tabpanel: {
    padding: '.571rem 1rem'
  },
  tab: {
    color: 'var(--erma-primary-0)',
    padding: '.571em 1em',
    background: 'var(--erma-primary-700)',
    borderWidth: '1px 1px 0px 1px',
    borderColor: 'var(--erma-secondary-220)',
    active: {
      borderColor: 'var(--erma-secondary-220)',
      color: 'var(--erma-primary-500)',
    }
  },
  activeBar: {
    background: 'var(--erma-primary-0)',
    height: "2px",
    bottom: "-1px"
  },
  extend: {
    tablistExtend: {
      gap: '.05rem'
    },
    tabExtend: {
      borderRadius: 'var(--erma-border-radius-sm)'
    },
    tabPanelExtend: {
      border: '1px solid var(--erma-secondary-220)'
    },
    activeBarExtend: {
      background: ' var(--erma-secondary-220)'//Rámeček kolem celeho těla tabs je 1px této barvy. Přechod mezi popiskem je bílou a dělá mezeru v rámečku. Tato barva tuto mezeru vyplní pomocí stylů v css().
    }
  },
  css: ({ dt }) => `
        div.p-tablist-tab-list {
          gap: ${dt('tabs.tablistExtend.gap')};
        }
        .p-tab {
          border-radius: ${dt('tabs.tabExtend.borderRadius')};
        }
        .p-tabpanels {
          border: ${dt('tabs.tabPanelExtend.border')};
        }
        .p-tablist-active-bar::before,
        .p-tablist-active-bar::after {
            content: "";
            position: absolute;
            top: 0;
            width: 1px;
            height: 100%;
            background-color: ${dt('tabs.activeBarExtend.background')};
        }
        .p-tablist-active-bar::before {
            left: 0;
        }
        .p-tablist-active-bar::after {
            right: 0;
        }
        `
};
